import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Transfer,
    Popconfirm,
    message
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {CloseOutlined} from '@ant-design/icons'
import {
    PaperClipOutlined,
    PlusCircleOutlined,
    FormOutlined,
    MobileOutlined,
    PhoneOutlined,
    WechatOutlined,
    MailOutlined,
    HomeOutlined,
    GlobalOutlined,
    FolderOpenOutlined,
    UserOutlined,
    HistoryOutlined
} from '@ant-design/icons'
import Edit from '../user/edit';
import moment from 'moment';

class XmView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: store.getState().data.info ? store.getState().data.info.id : 0,
            },
            visible: false,
            loading: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {
        this.props.NAV_CHANGE('/geren', ['首页', '个人资料'])
        this.getdata()
    }

    getdata = () => {
        let that = this
        fetch('/Geren/index', {
            method: "POST",
            // body: JSON.stringify(that.state.condition)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }
                that.setState({
                    condition: data.data
                })
            })
    }

    render() {
        return (
            <>
                <div className='pubtitle'>
                    <div className='l'>
                        <Space size={30}>
                            <span>个人信息</span>
                            {store.getState().data.info ?
                                <Edit id={this.state.condition.id} setinfo={this.props.SET_INFO}
                                      refresh={this.getdata.bind(this)} isbase={true}/> : null}
                        </Space>
                    </div>
                    <div className='r'>
                    </div>
                </div>
                <table className='xmtable4'>
                    <tr>
                        <td className="title" width={100}>用户名</td>
                        <td>{this.state.condition.username}</td>
                    </tr>
                    <tr>
                        <td className="title">姓名</td>
                        <td>{this.state.condition.name}</td>
                    </tr>
                    <tr>
                        <td className="title">联系电话</td>
                        <td>{this.state.condition.phone}</td>
                    </tr>
                </table>
            </>
        )
    }
}

export default XmView
